import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { multiStates } from "../../../data/usStates";
import { auth, db } from "../../../firebase";
import { collection, getDocs, addDoc, doc, query, where, updateDoc } from "firebase/firestore";
import { toast } from "react-hot-toast";
import { useAuthState } from "react-firebase-hooks/auth";
import PageHeading from "../../../components/common/PageHeading";
import FormAction from "../../../components/common/FormAction";
import RightBar from "../../../components/common/RightBar";
import Footer from "../../../components/common/Footer";
import MultiSelect from "../../../components/common/MultiSelect";
import FilterContainer from "../../../components/common/FilterContainer";

import { TiArrowBack } from "react-icons/ti";
import {
  Col,
  Input,
  Form,
  Row,
  Table,
  Checkbox,
  Select,
  Card,
  Button,
} from "antd";

import "./NewPropertyGroups.css";

const NewPropertyGroupsRightBar = [];

function NewPropertyGroups() {
  const [sortedInfo, setSortedInfo] = useState({});
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [properties, setProperties] = useState([]);
  const [filteredProperties, setFilteredProperties] = useState(properties);
  const [selectStates, setSelectStates] = useState([]);
  const [owners, setOwners] = useState([]);
  const [propertyGroups, setPropertyGroups] = useState([]);
  const [propertyGroupName, setPropertyGroupName] = useState("");
  const [user, loading] = useAuthState(auth);
  const [propertyGroup, setPropertyGroup] = useState({});
  const [initialValue, setInitialValue] = useState("");

  const { id } = useParams();

  const [companyName, setCompanyName] = useState("");
  const [isCompanyNameFetched, setIsCompanyNameFetched] = useState(false);
  const fetchCompanyName = async () => {
    try {
      const usersRef = collection(db, "allUsers");
      const userData = query(usersRef, where("uid", "==", user?.uid));
      const querySnapshot = await getDocs(userData);
      querySnapshot.forEach((doc) => {
        const res = doc.data();
        setCompanyName(res.companyName);
      });
      setIsCompanyNameFetched(true);
    } catch (error) {
      console.log("Error getting company name: ", error);
    }
  };
  useEffect(() => {
    fetchCompanyName();
  }, [user, loading]);

  useEffect(() => {
    if (!isCompanyNameFetched) return;
    const fetchProperties = async () => {
      try {
        const propertyUnitRef = collection(
          db,
          "companies",
          companyName,
          "properties"
        );
        const snapshot = await getDocs(propertyUnitRef);

        const fetchedData = snapshot.docs.map((doc) => ({
          id: doc.id,
          address:
            doc.data().propertyNameAddress.propertyName +
            " - " +
            doc.data().propertyNameAddress.propertyAddressOne +
            " - " +
            doc.data().propertyNameAddress.city +
            ", " +
            doc.data().propertyNameAddress.country +
            "-" +
            doc.data().propertyNameAddress.state,
          ...doc.data(),
        }));
        setProperties(fetchedData);
        setFilteredProperties(fetchedData);
      } catch (err) {
        console.error(err);
        alert(err.message);
      }
    };
    fetchProperties();
  }, [companyName, isCompanyNameFetched]);

  useEffect(() => {
    if (!isCompanyNameFetched) return;

    const fetchOwners = async () => {
      try {
        const ownerRef = collection(db, "companies", companyName, "owners");
        const snapshot = await getDocs(ownerRef);

        const fetchedData = snapshot.docs.map((doc) => ({
          id: doc.id,
          value:
            doc.data().ownerInfo.firstName +
            " - " +
            doc.data().ownerInfo.lastName,
          ...doc.data(),
        }));
        setOwners(fetchedData);
      } catch (err) {
        console.error(err);
        alert(err.message);
      }
    };
    fetchOwners();
  }, [companyName, isCompanyNameFetched]);

  useEffect(() => {
    if (!isCompanyNameFetched) return;

    const fetchPropertyGroups = async () => {
      try {
        const propertyGroupRef = collection(
          db,
          "companies",
          companyName,
          "propertyGroups"
        );
        const snapshot = await getDocs(propertyGroupRef);
        const fetchedData = snapshot.docs.map((doc) => ({
          id: doc.id,
          value: doc.data().propertyGroupName,
          ...doc.data(),
        }));
        setPropertyGroups(fetchedData);
        const propertyGr = propertyGroups.find((item) => {
          return item.id === id;
        });
        setPropertyGroup(propertyGr);
      } catch (err) {
        console.error(err);
        alert(err.message);
      }
    };
    fetchPropertyGroups();
  }, [companyName, isCompanyNameFetched]);

  useEffect(() => {
    console.log(id);
    console.log("propG", propertyGroups);
    const propertyGr = propertyGroups.find((item) => {
      console.log( "id", item.id)
      return item.id === id;
    });
    console.log("property group: ", propertyGr);
    setInitialValue(propertyGr?.propertyGroupName);
    setPropertyGroup(propertyGr);
    // setSelectedRowKeys(propertyGr?.properties);
  }, [propertyGroups]);

  console.log("after useEff", propertyGroup);

  const navigate = useNavigate();

  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const handleChange = (pagination, filters, sorter) => {
    console.log("Various parameters", pagination, filters, sorter);
    setSortedInfo(sorter);
  };

  const onCancel = () => {
    navigate("/generalsettings/property-groups");
  };

  const columns = [
    {
      title: "Propert Name",
      dataIndex: "propertyName",
      key: "propertyName",
      render: (_, record) => (
        <span className="onclick-text">
          {record.propertyNameAddress.propertyName}
        </span>
      ),
      sorter: (a, b) => a.propertyName.length - b.propertyName.length,
      sortOrder:
        sortedInfo.columnKey === "propertyName" ? sortedInfo.order : null,
      ellipsis: true,
    },
    {
      title: "Address",
      dataIndex: "address",
      key: "address",
      render: (_, record) => (
        <span className="onclick-text">{record.address}</span>
      ),
      sorter: (a, b) => a.address.length - b.address.length,
      sortOrder: sortedInfo.columnKey === "address" ? sortedInfo.order : null,
      ellipsis: true,
    },
  ];

  const handleFormSubmit = async () => {
    const companiesRef = collection(db, "companies");
    const companyDocRef = doc(companiesRef,companyName);
    const propertyGroupp = {
      propertyGroupName: propertyGroupName,
      properties: selectedRowKeys,
    };

    if (id) {
      const propertyGroupUpdateRef = doc(companyDocRef, "propertyGroups", id);
      if (propertyGroupName !== "") {
        try {
          await updateDoc(propertyGroupUpdateRef, propertyGroupp);
          toast.success("Property Group updated successfully");
          navigate("/generalsettings/property-groups");
        } catch (err) {
          console.error(err);
          alert(err.message);
        }
      } else {
        toast.error("Property Group name cant be blank");
      }
    } else {
      const propertyGroupRef = collection(companyDocRef, "propertyGroups");
      if (propertyGroupName !== "") {
        try {
          await addDoc(propertyGroupRef, {
            propertyGroupName: propertyGroupName,
            properties: selectedRowKeys,
          });
          toast.success("Property Group created successfully");
          navigate("/generalsettings/property-groups");
        } catch (err) {
          console.error(err);
          alert(err.message);
        }
      } else {
        toast.error("Property Group name cant be blank");
      }
    }
  };
  const onFinishFailed = (errorInfo) => {
    toast.error("There are problems with one or more required fields");
    console.log("Failed:", errorInfo);
  };

  const handleSearchFormSubmit = (values) => {
    Object.keys(values).forEach((field) => {
      if (values[field] === undefined) {
        values[field] = "";
      }
    });
    const filteredDataSource = properties.filter(
      (record) =>
        (selectStates.length === 0 ||
          selectStates.some((value) =>
            record?.propertyNameAddress?.state
              ?.toLowerCase()
              .includes(value.toLowerCase())
          )) &&
        (values.propertyGroupName === "" ||
          Object.values(record.propertyGroups).some((value) =>
            value.toLowerCase().includes(values.propertyGroupName.toLowerCase())
          )) &&
        (values.address === "" ||
          record?.address
            ?.toLowerCase()
            .includes(values.address.toLowerCase())) &&
        (values.zipCode === "" ||
          record?.propertyNameAddress?.zipCode
            ?.toLowerCase()
            .includes(values.zipCode.toLowerCase())) &&
        (values.propertyName === "" ||
          record?.propertyNameAddress?.propertyName
            ?.toLowerCase()
            .includes(values.propertyName.toLowerCase())) &&
        (values.portfolio === "" ||
          record?.propertyInformation?.portfolio
            ?.toLowerCase()
            .includes(values.portfolio.toLowerCase())) &&
        (values.owner === "" ||
          Object.values(record?.ownersAndFinancials?.owners).some((value) =>
            value?.owner.toLowerCase().includes(values.owner.toLowerCase())
          ))
    );
    console.log("filtered data", filteredDataSource);
    setFilteredProperties(filteredDataSource);
  };
  const onSearchFinishFailed = (errorInfo) => {
    toast.error("There are problems with one or more required fields");
    console.log("Failed:", errorInfo);
  };
  const initialValues = {
    propertyGroupName: initialValue,
  };


  return (
    <>
      <div className="page-container">
        <div className="new-property-groups main-container">
          <div
            className="back-container"
            onClick={() => navigate("/generalsettings/property-groups")}
          >
            <TiArrowBack size={20} />
            <span>Back to Manage Property Groups</span>
          </div>
          <PageHeading heading="New Property Group" />
          <div className="page-content">
            <Row>
              <Col span={12}>
                <Form
                  layout="vertical"
                  onFinish={handleFormSubmit}
                  onFinishFailed={onFinishFailed}
                  initialValues={initialValues}
                >
                  <Form.Item
                    label="Property Group Name"
                    required
                    name="propertyGroupName"
                  >
                    <Input
                      value={propertyGroupName}
                      onChange={(e) => setPropertyGroupName(e.target.value)}
                    />
                  </Form.Item>
                  <FormAction cancel={onCancel} submit="submit" />
                </Form>
              </Col>
            </Row>
            <FilterContainer heading="Filter properties by using any of the search filters below:">
              <Row>
                <Col span={24}>
                  <Form
                    labelCol={{ span: 8 }}
                    wrapperCol={{ span: 14 }}
                    colon={false}
                    onFinish={handleSearchFormSubmit}
                    onFinishFailed={onSearchFinishFailed}
                  >
                    <Form.Item label="Property Name" name="propertyName">
                      <Input />
                    </Form.Item>
                    <Form.Item label="Address" name="address">
                      <Input />
                    </Form.Item>
                    <Form.Item label="Zip" name="zipCode">
                      <Input />
                    </Form.Item>
                    <Form.Item label="Property Group" name="propertyGroupName">
                      <Select options={propertyGroups} allowClear showSearch />
                    </Form.Item>
                    <Form.Item label="Portfolio" name="portfolio">
                      <Select
                        allowClear
                        showSearch
                        options={[
                          { value: "sayeagle" },
                          { value: "portfolio 2" },
                        ]}
                      />
                    </Form.Item>
                    <Form.Item label="Owner" name="owner">
                      <Select options={owners} allowClear showSearch />
                    </Form.Item>
                    <Form.Item label="State" name="state">
                      <MultiSelect
                        options={multiStates}
                        callBackItems={setSelectStates}
                      />
                    </Form.Item>
                    <Form.Item
                      label=" "
                      name="showOnlySelectedProperties"
                      valuePropName="checked"
                    >
                      <Checkbox>Show only selected properties</Checkbox>
                    </Form.Item>
                    <Form.Item
                      label=" "
                      name="showHiddenProperties"
                      valuePropName="checked"
                    >
                      <Checkbox>Show hidden properties</Checkbox>
                    </Form.Item>
                    <Form.Item label=" ">
                      <Button type="primary" htmlType="submit">
                        Search
                      </Button>
                    </Form.Item>
                  </Form>
                </Col>
              </Row>
            </FilterContainer>
            <Card title="Properties" className="card">
              <div className="property-groups-list">
                <Table
                  className="card-container"
                  columns={columns}
                  dataSource={filteredProperties}
                  onChange={handleChange}
                  rowSelection={rowSelection}
                  rowKey={(obj) => obj.id}
                />
              </div>
              <br />
              <FormAction
                cancel={onCancel}
                save={handleFormSubmit}
                disable={propertyGroupName === "" ? true : false}
              />
              {selectedRowKeys.length <= 1 ? (
                <span className="property-number">
                  {selectedRowKeys.length} property selected
                </span>
              ) : (
                <span className="property-number">
                  {selectedRowKeys.length} properties selected
                </span>
              )}
            </Card>
            <Footer />
          </div>
        </div>
      </div>
      <div className="RightSidebar">
        <RightBar RightBarData={NewPropertyGroupsRightBar} />
      </div>
    </>
  );
}

export default NewPropertyGroups;
